module.exports = __webpack_public_path__ + "static/priviliges-9-f2183ed12ba2a7bb2c5d9cf39504aaf4.png";